import WebsiteIcon from "./WebsiteIcon";
import { websiteIcon } from "./icon-catalogue";

const ARROWS = new Set(["arrow-right", "arrow-up-right-from-square"]);

/** Leaves old button DOM unchanged until an explicit catalogue icon has been chosen. */
export default function IconLabel({
  iconId,
  position,
  lookSystem = false,
  children,
}: {
  iconId?: unknown;
  position?: string;
  /** An arrow icon is then the one a look-system card nudges; outside a card it stays still. */
  lookSystem?: boolean;
  children: React.ReactNode;
}) {
  if (!websiteIcon(iconId)) return children;
  const icon = (
    <WebsiteIcon
      name={iconId}
      className="inline-block size-[1em] shrink-0 align-middle"
      cardArrow={lookSystem && ARROWS.has(String(iconId))}
    />
  );
  return (
    <span className="inline-flex items-center justify-center gap-2">
      {position !== "after" && icon}
      <span>{children}</span>
      {position === "after" && icon}
    </span>
  );
}
